import RecurrenceExceptionModalHeader from './RecurrenceExceptionModalHeader';

export default RecurrenceExceptionModalHeader;
